import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M9.134 4.753c0 .382-.128.734-.344 1.015l.747 1.59a3.76 3.76 0 0 1 3.425.87l2.057-1.562a1.666 1.666 0 1 1 .867 1.225l-2.038 1.547c.218.476.34 1.006.34 1.564 0 .408-.065.8-.185 1.167l1.857 1.127a1.666 1.666 0 1 1-.846 1.242l-1.754-1.065a3.754 3.754 0 0 1-6.49-1.661l-2.01.032a1.665 1.665 0 1 1 .093-1.502l1.893-.03c.175-.94.7-1.758 1.436-2.311l-.744-1.582a1.666 1.666 0 1 1 1.696-1.666m1.301 8.502a2.253 2.253 0 1 0 0-4.505 2.253 2.253 0 0 0 0 4.505"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNetwork;
